export const defaultHeaders = [
  { title: 'Supplier name', field: 'supplierName', isShowSortIcon: false, class: 'supplierName' },
  { title: 'Order method', field: 'orderingMethod', isShowSortIcon: false, class: 'orderMethod' },
  { title: 'Supplier type', field: 'suppliertype', isShowSortIcon: false, class: 'type' },
  { title: 'Date', field: 'activityDate', isShowSortIcon: false, class: 'activityDate' },
  { title: 'Activity type', field: 'activityType', isShowSortIcon: false, class: 'activityType' },
  { title: 'Item type', field: 'itemType', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item name', field: 'itemName', isShowSortIcon: false, class: 'itemName' },
  { title: 'PO #', field: 'pos', isShowSortIcon: false, class: 'pOnumber' },
  { title: 'Payment term', field: 'paymentStatus', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'RO #', field: 'ros', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Cost', field: 'cost', isShowSortIcon: false, class: 'cost', total: 0 },
  { title: 'Quantity', field: 'quantity', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Tax', field: 'taxedAmount', isShowSortIcon: false, class: 'tax', total: 0 },
  { title: 'Subtotal', field: 'subTotal', isShowSortIcon: false, class: 'subtotal', total: 0 },
  { title: 'Order status', field: 'orderingStatus', isShowSortIcon: false, class: 'orderingStatus' },
];
export const locationReportColumns = [
  { title: 'Invoice #', field: 'roInvoiceNumber', isShowSortIcon: false, class: 'invoice-number' },
  { title: 'Location', field: 'location', isShowSortIcon: false, class: 'location' },
  { title: 'Warehouse', field: 'warehouse', isShowSortIcon: false, class: 'warehouse' },
];

export const locationReportColumnsCVS = [
  { name: 'Invoice #', value: 'roInvoiceNumber', isChecked: true },
  { name: 'Location', value: 'location', isChecked: true },
  { name: 'Warehouse', value: 'warehouse', isChecked: true },
];
export const defaultStats = [
  {
    title: 'Total volume purchased',
    icon: 'fal fa-warehouse-alt',
    total: 0,
    percent: 0,
    value: 'totalVolume',
  },
  {
    title: 'Total number of items purchased',
    icon: 'fal fa-boxes',
    total: 0,
    percent: 0,
    value: 'totalNumber',
  },
  {
    title: 'Total Purchase Order value',
    icon: 'fal fa-file-invoice',
    total: 0,
    percent: 0,
    value: 'totalPurchase',
  },
];

export const itemPurchasedStats = [
  {
    title: 'Net purchase value',
    icon: 'total-net-purchased.svg',
    total: 0,
    percent: 0,
    value: 'netValue',
  },
  {
    title: 'Item purchase value',
    icon: 'item-purchase-value.svg',
    total: 0,
    percent: 0,
    value: 'totalPurchase',
  },
  {
    title: 'Item return value',
    icon: 'return-value.svg',
    total: 0,
    percent: 0,
    value: 'totalVolume',
  },
  {
    title: 'Core return value',
    icon: 'return-value.svg',
    total: 0,
    percent: 0,
    value: 'totalNumber',
  },
];
export const supplierReportUpdated = [
  { title: 'Supplier name', field: 'supplierName', class: 'supplierName' },
  { title: 'Supplier Type', field: 'suppliertype', class: 'type' },
  { title: 'Item purchase value', field: 'totalNumberOfItemsPurchased', class: 'itemPurched', total: 0 },
  { title: 'Item return value', field: 'totalNumberOfItemsReturned', class: 'itemPurched', total: 0 },
  { title: 'Core return value', field: 'totalNumberOfCoreReturned', class: 'volPurched', total: 0 },
  { title: 'Net purchase value', field: 'totalNetPurchaseValue', class: 'totalPurchase', total: 0 },
];
export const frozenHeaders = [
  { title: 'Supplier Invoice Date', field: 'supplierInvDate', isShowSortIcon: false, class: 'supplierInvDate' },
  { title: 'Marked Core date', field: 'markedCoreOn', isShowSortIcon: false, class: 'markedCoreOn' },
  { title: 'Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'shippedDate' },
];
export const coreReturnedheaders = [
  { title: 'Supplier Invoice Date', field: 'supplierInvDate', isShowSortIcon: false, class: 'supplierInvDate' },
  { title: 'Marked Core date', field: 'coreCreationDate', isShowSortIcon: false, class: 'markedCoreOn' },
  { title: 'Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'shippedDate' },
  // { title: 'Delivered Date', field: 'deliveredDate', isShowSortIcon: false, class: 'deliveredDate' },
  // { title: 'Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'refundedDate' },

  { title: 'Supplier name', field: 'supplierName', isShowSortIcon: false, class: 'supplierName' },
  { title: 'Order method', field: 'orderingMethod', isShowSortIcon: false, class: 'orderMethod' },
  // { title: 'Date', field: 'activityDate', isShowSortIcon: false, class: 'activityDate' },
  { title: 'Item type', field: 'itemType', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item #', field: 'itemNumber', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item name', field: 'itemName', isShowSortIcon: false, class: 'itemName' },
  { title: 'Order status', field: 'orderingStatus', isShowSortIcon: false, class: 'orderingStatus' },
  { title: 'PO #', field: 'pos', isShowSortIcon: false, class: 'pOnumber' },
  { title: 'RO #', field: 'ros', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Credit #', field: 'creditNo', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Qty returned', field: 'quantity', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Total pre-tax', field: 'coreTotalPreTax', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Tax', field: 'coreTaxAmt', isShowSortIcon: false, class: 'tax', total: 0 },
  { title: 'Total post-tax', field: 'coreTotalPostTax', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Refund amount', field: 'refundedAmount', isShowSortIcon: false, class: 'quantity', total: 0 },
  // { title: 'Creation date', field: 'coreCreationDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Core Creation date', field: 'coreCreationDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Core Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Core Delivered Date', field: 'deliveredDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Core Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'paymentStatus' },
];

export const itemsReturnedHeaders = [
  { title: 'Supplier Invoice Date', field: 'supplierInvDate', isShowSortIcon: false, class: 'supplierInvDate' },
  { title: 'Creation date', field: 'returnCreationDate', isShowSortIcon: false, class: 'markedCoreOn' },
  { title: 'Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'shippedDate' },
  // { title: 'Delivered Date', field: 'deliveredDate', isShowSortIcon: false, class: 'deliveredDate' },
  // { title: 'Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'refundedDate' },

  { title: 'Supplier name', field: 'supplierName', isShowSortIcon: false, class: 'supplierName' },
  { title: 'Order method', field: 'orderingMethod', isShowSortIcon: false, class: 'orderMethod' },
  // { title: 'Date', field: 'activityDate', isShowSortIcon: false, class: 'activityDate' },
  { title: 'Item type', field: 'itemType', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item #', field: 'itemNumber', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item name', field: 'itemName', isShowSortIcon: false, class: 'itemName' },
  { title: 'Supplier invoice #', field: 'supplierReturnInv', isShowSortIcon: false, class: 'invoice-number' },
  { title: 'Credit #', field: 'creditNo', isShowSortIcon: false, class: 'invoice-number' },
  { title: 'Supplier Return Invoice Date', field: 'supplierReturnInvDate', isShowSortIcon: false, class: 'date' },
  // { title: 'Delivered Date', field: 'deliveryDate', isShowSortIcon: false, class: 'date' },
  // { title: 'Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'date' },
  { title: 'Order status', field: 'orderingStatus', isShowSortIcon: false, class: 'orderingStatus' },
  { title: 'PO #', field: 'pos', isShowSortIcon: false, class: 'pOnumber' },
  { title: 'RO #', field: 'ros', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Unit cost', field: 'returnUnitCost', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Qty returned', field: 'quantityReturn', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Total pre-tax', field: 'returnTotalPreTax', isShowSortIcon: false, class: 'quantity', total: 0 }, // unit cost * Qty
  { title: 'Tax', field: 'returnTaxAmt', isShowSortIcon: false, class: 'tax', total: 0 },
  { title: 'Total post-tax', field: 'returnTotalPostTax', isShowSortIcon: false, class: 'quantity', total: 0 }, //total pre-tax + tax
  { title: 'Refund amount', field: 'refundedAmount', isShowSortIcon: false, class: 'quantity', total: 0 },

  // { title: 'Creation date', field: 'returnCreationDate', isShowSortIcon: false, class: 'creationDate' },
  { title: 'Return Creation date', field: 'returnCreationDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Delivered Date', field: 'deliveredDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Supplier Invoice Date', field: 'supplierInvDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Supplier Invoice Number', field: 'returnSupplierInvNum', isShowSortIcon: false, class: 'paymentStatus' },
  // { title: 'Core Creation Date', field: 'returnCreationDate', isShowSortIcon: false, class: 'paymentStatus' },
  // { title: 'Core Shipped Date', field: 'shippedDate', isShowSortIcon: false, class: 'paymentStatus' },
  // { title: 'Core Delivered Date', field: 'deliveredDate', isShowSortIcon: false, class: 'paymentStatus' },
  // { title: 'Core Refunded Date', field: 'refundedDate', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Return Type', field: 'returnType', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Total post-tax', field: 'returnTotalPostTax', isShowSortIcon: false, class: 'quantity', total: 0 }, //total pre-tax + tax //new filed
  // { title: 'Delivered Date', field: 'deliveryDate', isShowSortIcon: false, class: 'creationDate' },
  // { title: 'Creation date', field: 'returnCreationDate', isShowSortIcon: false, class: 'creationDate' },
  // { title: 'Cost', field: 'cost', isShowSortIcon: false, class: 'cost', total: 0 },
  // { title: 'Subtotal', field: 'itemReturn', isShowSortIcon: false, class: 'subtotal', total: 0 },
];

export const itemsPurchasedHeaders = [
  { title: 'Supplier invoice date', field: 'supplierInvDate', isShowSortIcon: false, class: 'date' },
  { title: 'Creation date', field: 'creationDate', isShowSortIcon: false, class: 'creationDate' },
  { title: 'Ordered date', field: 'orderedDate', isShowSortIcon: false, class: 'orderedDate' },
  { title: 'Supplier name', field: 'supplierName', isShowSortIcon: false, class: 'supplierName' },
  { title: 'PO #', field: 'pos', isShowSortIcon: false, class: 'pOnumber' },
  { title: 'RO #', field: 'ros', isShowSortIcon: false, class: 'rOnumber' },
  { title: 'Order method', field: 'orderingMethod', isShowSortIcon: false, class: 'orderMethod' },
  { title: 'Order status', field: 'orderingStatus', isShowSortIcon: false, class: 'orderingStatus' },
  { title: 'Payment term', field: 'paymentTerms', isShowSortIcon: false, class: 'paymentStatus' },
  { title: 'Item type', field: 'itemType', isShowSortIcon: false, class: 'itemType' },
  { title: 'Item #', field: 'itemNumber', isShowSortIcon: false, class: 'pOnumber' },
  { title: 'Item name', field: 'itemName', isShowSortIcon: false, class: 'itemName' },
  { title: 'Unit cost', field: 'unitCost', isShowSortIcon: false, class: 'cost' },
  { title: 'Qty', field: 'quantity', isShowSortIcon: false, class: 'quantity', total: 0 },
  { title: 'Total pre-tax', field: 'totalPreTax', isShowSortIcon: false, class: 'cost', total: 0 },
  { title: 'Tax', field: 'taxedAmount', isShowSortIcon: false, class: 'tax', total: 0 },
  { title: 'Total post-tax', field: 'totalPostTax', isShowSortIcon: false, class: 'cost', total: 0 },
  { title: 'Delivered date', field: 'deliveryDate', isShowSortIcon: false, class: 'deliveredDate' },
  // { title: 'Date', field: 'activityDate', isShowSortIcon: false, class: 'activityDate' },
  // { title: 'Supplier type', field: 'suppliertype', isShowSortIcon: false, class: 'type' },
  // { title: 'Cost', field: 'cost', isShowSortIcon: false, class: 'cost', total: 0 },
  // { title: 'Subtotal', field: 'subTotal', isShowSortIcon: false, class: 'subtotal', total: 0 },
];

export const supplierDrillDownCSV = [
  { name: 'Activity type', value: 'activityType', isChecked: true },

  { name: 'Supplier invoice date', value: 'supplierInvDate', isChecked: true },
  { name: 'Creation date', value: 'creationDate', isChecked: true, },
  { name: 'Ordered date', value: 'orderedDate', isChecked: true, },

  { name: 'Supplier name', value: 'supplierName', isChecked: true },
  { name: 'Supplier type', value: 'suppliertype', isChecked: true },
  { name: 'Supplier Invoice #', value: 'supplierInvNum', isChecked: true,},

  { name: 'Date', value: 'activityDate', isChecked: true },
  { name: 'Item type', value: 'itemType', isChecked: true },
  { name: 'Item name', value: 'itemName', isChecked: true },
  { name: 'Item #', value: 'itemNumber', isChecked: true, },

  { name: 'Order method', value: 'orderingMethod', isChecked: true },
  { name: 'Order status', value: 'orderingStatus', isChecked: true },
  { name: 'PO #', value: 'pos', isChecked: true },
  { name: 'RO #', value: 'ros', isChecked: true },
  { name: 'Payment term', value: 'paymentTerms', isChecked: true },
  { name: 'Cost', value: 'cost', isChecked: true },
  { name: 'Qty returned', value: 'quantity', isChecked: true },
  { name: 'Tax', value: 'taxedAmount', isChecked: true },
  { name: 'Subtotal', value: 'subTotal', isChecked: true },
  { name: 'Delivered date', value: 'deliveryDate', isChecked: true,},

  { name: 'Core Creation date', value: 'coreCreationDate', isChecked: true, },
  { name: 'Core Shipped Date', value: 'shippedDate', isChecked: true, },
  { name: 'Core Delivered Date', value: 'deliveredDate', isChecked: true, },
  { name: 'Core Refunded Date', value: 'refundedDate', isChecked: true, },

  { name: 'Return Supplier Invoice Number', value: 'returnSupplierInvNum', isChecked: true,},
  { name: 'Return Creation date', value: 'returnCreationDate', isChecked: true, },
  { name: 'Return Shipped Date', value: 'shippedDate', isChecked: true, },
  { name: 'Return Delivered Date', value: 'deliveredDate', isChecked: true, },
  { name: 'Return Refunded Date', value: 'refundedDate', isChecked: true, },
  { name: 'Return Supplier Invoice Date', value: 'supplierInvDate', isChecked: true, },
  
];
export const headerSortStateUpdated = {
  supplierName: false,
  suppliertype: false,
  totalNumberOfItemsPurchased: false,
  totalNumberOfItemsReturned: false,
  totalNumberOfCoreReturned: false,
  totalNetPurchaseValue: false,
};
export const supplierReport = [
  { title: 'Supplier name', field: 'supplierName', class: 'supplierName' },
  { title: 'Supplier Type', field: 'suppliertype', class: 'type' },
  { title: 'Number of items purchased', field: 'totalNumberOfItemsPurchased', class: 'itemPurched', total: 0 },
  { title: 'Volume purchased', field: 'totalVolumePurchased', class: 'volPurched', total: 0 },
  { title: 'Total Purchase value', field: 'totalPurchaseValue', class: 'totalPurchase', total: 0 },
];
export const headerSortState = {
  supplierName: false,
  suppliertype: false,
  totalNumberOfItemsPurchased: false,
  totalVolumePurchased: false,
  totalPurchaseValue: false,
};

export const itemPurchasedDates = [
  { title: 'Supplier Invoice Date ', field: 'supplierInvoiceDate' },
  { title: 'Creation Date', field: 'creationDate' },
  { title: 'Ordered Date', field: 'orderedDate'},
  { title: 'Delivered Date ', field: 'deliveryDate' },
];

export const itemReturneddDates = [
  { title: 'Supplier Return Invoice Date ', field: 'supplierInvoiceDate' },
  { title: 'Refunded Date', field: 'refundedDate' },
  { title: 'Delivered Date ', field: 'deliveredDate' },
];

export const coreReturneddDates = [
  { title: 'Core Creation Date', field: 'creationDate' },
  { title: 'Core Delivered Date ', field: 'deliveredDate' },
  { title: 'Core Refunded Date', field: 'refundedDate' },
];
